<template>
  <label class="input-check"
         @input="sendInputEvent($event)"
         @focus="sendFocusEvent($event)"
         @blur="sendBlurEvent($event)"
         @click="sendClickEvent($event)"
         @mousedown="sendMousedownEvent($event)"
         @mouseover="sendMouseoverEvent($event)"
         @mouseout="sendMouseoutEvent($event)"
         @keydown="sendKeydownEvent($event)"
         @keyup="sendKeyupEvent($event)"
  >
    <input type="checkbox"
           class="checkbox"
           :name="name"
           :id="id"
           :value="value"
           :checked="checked === value"
           :tabindex="tabindex"
           @change="updateValue"
    >
    <span class="checktxt"><slot></slot></span>
  </label>
</template>

<script>
import FormEvent from '../../components/mixin/FormEvent'

export default {
  name: 'input-check',
  mixins: [FormEvent],
  model: {
    prop: 'checked',
    event: 'input'
  },
  props: {
    name: {type: String},
    id: {type: String},
    tabindex: {type: String},
    checked: {},
    value: {},
    trackingName: { type: String }
  },
  computed: {
    group () {
      return ('$parent' in this && this.$parent.$options.name === 'vue-group') ? this.$parent : null
    },
    input () {
      return this.group ? this.group.value : this.checked
    }
  },

  methods: {
    updateValue (e) {
      this.sendChangeEvent(e)
      let value = e.target.checked ? this.value : null
      if (this.group) {
        this.group.$emit('input', value)
        this.group.$emit('checked', value)
      } else {
        this.$emit('input', value)
        this.$emit('checked', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.input-check {
  >.checkbox{
    display: none;
  }

  >.checktxt{
    padding-left: 20px;
    position:relative;
    margin-right: 20px;
  }

  >.checktxt::before{
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 16px;
    height: 16px;
    border: 1px solid $secondary;
  }

  >.checkbox:checked + .checktxt::after{
    content: "";
    display: block;
    position: absolute;
    top: 1px;
    left: 5px;
    width: 6px;
    height: 12px;
    transform: rotate(50deg);
    border-bottom: 3px solid $primary;
    border-right: 3px solid $primary;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/input/InputCheck.vue